<template>
<div>
<div class="inputContainer">
  <el-row :gutter="5">
    <el-col :span="15">
      <div class="grid-content">
        <el-button @click="handleСreate()" icon="el-icon-circle-plus" type="primary">Create new project</el-button>
      </div>
    </el-col>
    <el-col :span="2">
      <div class="grid-content righty">
        <el-switch
        v-model="showAll"
        active-color="#ff4949"
        inactive-color="#13ce66"
      >
      </el-switch> 
      </div>
    </el-col>
    <el-col :span="4">
      <div class="grid-content textGrey lefty">
        <h5 v-if="showAll">showing everything</h5>
        <h5 v-else-if="!showAll">showing active only</h5>
      </div>
    </el-col>
    <el-col :span="3">
      <div class="grid-content">
        <el-input 
          v-on:input="filterByName" 
          clearable 
          placeholder="enter name to filter" 
          class="filterInput" 
          v-model="nameFilter"></el-input>
      </div>
    </el-col>
  </el-row>
</div>
<div class="projectsSummary" role="status" aria-live="polite" :aria-busy="summaryLoading ? 'true' : 'false'">
  <template v-if="summaryLoading">Loading project totals…</template>
  <template v-else-if="summaryError">
    <span>Project totals unavailable.</span>
    <el-button type="text" size="small" @click="fetchSummary">Retry</el-button>
  </template>
  <template v-else-if="summary">
    <span>Active projects: <strong>{{ formatSummaryNumber(summary.active_projects_count) }}</strong></span>
    <span>Average scheduled: <strong>{{ formatSummaryNumber(summary.scheduled_visits) }}</strong></span>
  </template>
</div>
<el-table
    v-loading="loading"
    ref="projectsTable"
    :data="prepareNews()"
    style="width: 100%"
    :default-sort="{prop: 'id', order: 'descending'}"
    :row-class-name="tableRowClassName">
    <el-table-column
      sortable
      prop="id"
      label="ID"
      width="70"
      >
    </el-table-column>
    <el-table-column
      sortable
      prop="name"
      label="Name"
      min-width="200"
      >
      <template slot-scope="scope">
        <router-link :to="projectLink(scope.row)">{{scope.row.name}}</router-link>
        <div v-if="scope.row.tags && scope.row.tags.length" class="projectTags">
          <span
            v-for="(tag, index) in visibleProjectTags(scope.row.tags)"
            :key="scope.row.id + '-' + tag + '-' + index"
            class="projectTag"
          >{{tag}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      sortable
      prop="status"
      label="Status"
      width="100"
    >
    </el-table-column>
    <el-table-column
      sortable
      prop="updated_at"
      label="Last updated"
      :formatter="updatedDateFormatter"
    >
    </el-table-column>
    <el-table-column
      label="Operations">
      <template slot-scope="scope">
       
        <el-tooltip class="item" effect="dark" content="Rename or change dates" placement="top-end">
        <el-button
          size="mini" icon="el-icon-edit-outline"
          @click="handleEdit(scope.$index, scope.row)"
         ></el-button>
        </el-tooltip>
        <el-button
          size="mini"
          type="danger"
          icon="el-icon-delete"
          @click="handleDelete(scope.$index, scope.row)"></el-button>
      </template>
    </el-table-column>
    <el-table-column
      sortable
      label="Visits"
      prop="scheduled_avg"
      width="100"
    >
    </el-table-column>
     <el-table-column
      sortable
      label="Author"
      prop="user_name"
    >
    </el-table-column>
    <el-table-column
      sortable
      label="Description"
      prop="description"
    >
    </el-table-column>
</el-table>
<!-- dialogus -->
<el-dialog
  title="Edit project"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
  <el-row>
  <el-alert
    class="projectEditWarning"
    title="This is where you can change the most important properties of your project: state, period of activity and it's name"
    type="warning">
  </el-alert>
  <span>Edit project name</span>
  <div class="inputContainer">
  <el-input
    placeholder="Please specify new name"
    v-model="projectView.name"
    clearable>
  </el-input>
  </div>
  <div class="block">
    <span class="demonstration">Choose active dates range</span>
    <el-date-picker
      width="850"
      v-model="projectView.daterange"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="To"
      start-placeholder="Start date"
      end-placeholder="End date"
      :picker-options="pickerOptions">
    </el-date-picker>
  </div>
  <div class="block inputContainer">
    <el-input
      placeholder="Set any description you want"
      v-model="projectView.description"
      clearable>
    </el-input>
  </div>
  <div class="block inputContainer">
    <el-divider content-position="left">Tags</el-divider>
    <el-col :span="16" class="specControl">
        <el-row>
            <el-tag
                v-for="tag in projectView.tags"
                :key="tag"
                closable
                @close="handleCloseIncludeTags(tag)"
                >
                {{tag}}
            </el-tag>
        </el-row>
        <el-row>
            <el-col :span="16">
                <el-input v-model="tagIncludeInput" clearable=""></el-input>
            </el-col>
            <el-col :span="8">
                <el-button id="addTagButton" @click="addIncludeTag()" type="danger">Add tag</el-button>
            </el-col>
        </el-row>
    </el-col>
  </div>
  </el-row>
  <el-row>
    <el-col :span="12"><el-button @click="handleClose">Cancel</el-button></el-col>
    <el-col align="right" :span="12"><el-button icon="el-icon-success" type="primary" @click="handleUpdateProject">Update project</el-button></el-col>
  </el-row>
  <span slot="footer" class="dialog-footer">
    
    
  </span>
</el-dialog>
<!-- dialogus -->
<!-- dialogus for creation -->
<el-dialog
  title="Create project"
  :visible.sync="createDialogVisible"
  width="30%"
  :before-close="handleClose">
  <span>New project name</span>
  <div class="inputContainer">
  <el-input
    placeholder="Please specify a name"
    v-model="createProjectView.name"
    minlength="1"
    clearable>
  </el-input>
  </div>
  <div class="block">
    <span class="demonstration">Choose active dates range</span>
    <el-date-picker
      width="850"
      v-model="createProjectView.daterange"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="To"
      start-placeholder="Start date"
      end-placeholder="End date"
      :picker-options="pickerOptions">
    </el-date-picker>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">Cancel</el-button>
    <el-button icon="el-icon-danger" type="primary" @click="handleSaveNewProject">Create project</el-button>
  </span>
</el-dialog>
<!-- dialogus -->
</div>
</template>

<style>
  .projectsSummary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 24px;
    min-height: 32px;
    margin: 12px 0;
    color: #606266;
    font-size: 14px;
  }
  .projectsSummary strong {
    color: #303133;
    font-variant-numeric: tabular-nums;
  }
  .lefty{
    text-align: left;
  }
  .righty{
    text-align: right;
  }
  .el-button--success {
    padding: 5px 5px 5px 5px !important;
    margin-top: -2px;
  }
  .inputContainer {
    margin-top:10px;
    margin-bottom: 10px;
  }
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-date-editor {
    width: 100% !important;
    margin-top:10px;
  }
  .statusTag{
    margin-left: 10px;
  }
  .projectEditWarning{
    margin-bottom: 20px;
  }
  .textGrey {
    color: #aaa;
    margin-top:2px;
  }
  .filterInput .el-input__inner{
    height:25px !important;
    padding:5px;
    margin-top:-2px;
  }
  .cell a{
    color: grey;
    text-decoration: underline dotted grey !important;
  }
  .projectTags {
    display: flex;
    flex-wrap: wrap;
    margin-top: 4px;
  }
  .projectTags:empty {
    display: none;
  }
  .projectTag {
    display: inline-block;
    margin: 2px 4px 0 0;
    padding: 1px 6px;
    color: #606266;
    font-size: 11px;
    line-height: 18px;
    white-space: nowrap;
    background: #f4f4f5;
    border: 1px solid #d3d4d6;
    border-radius: 3px;
  }
</style>

<script>
import { mapState, mapGetters } from 'vuex'

import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'

import DataBox from '../../components/DataBox';
import moment from 'moment';
import ProjectsService from '../../services/projects.service'

const isShowAllQuery = value => ['1', 'true'].includes(String(value).toLowerCase())

export default {
  name: 'ProjectsList',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  components: {
    DataBox
  },

  props: {
    limit: { type: Number },
    page: { type: Number }
  },

  watch: {
    'pagination.limit': function () {
      this.$router.replace({
        query: this.useInUrlQueryPropList
      })
      // fetchData commented to avoid duplicate API calls when limit passed via query string: https://front.lpata.ru/projects?limit=20
      // this.fetchData()
    },
    'pagination.page': function () {
      this.$router.replace({
        query: this.useInUrlQueryPropList
      })
      // fetchData commented to avoid duplicate API calls when page passed via query string: https://front.lpata.ru/projects?page=20
      // this.fetchData()
    },
    limit: {
      handler: function (newVal) {
        this.$store.commit('news/SET_PAGINATION', { limit: newVal })
      },
      immediate: true
    },
    page: {
      handler: function (newVal) {
        this.$store.commit('news/SET_PAGINATION', { page: newVal })
      },
      immediate: true
    },
    '$route.query.show_all': function (newVal) {
      const showAll = isShowAllQuery(newVal)

      if (this.showAll !== showAll) {
        this.showAll = showAll
      }
    },
    showAll: {
      handler: function (newVal, oldVal) {
        if (oldVal === undefined || newVal === oldVal) {
          return
        }

        if (isShowAllQuery(this.$route.query.show_all) !== newVal) {
          this.$router.replace({
            query: this.useInUrlQueryPropList
          })
        }
        this.fetchData()
      },
      immediate: true
    }
  },

  data () {
    return {
      playbookToSchedule:[],
      newsText: 'Projects main page',
      projectsList: [],
      dialogVisible: false,
      createDialogVisible: false,
      tagIncludeInput:'',
      showAll: isShowAllQuery(this.$route.query.show_all),
      nameFilter: '',
      summary: null,
      summaryLoading: false,
      summaryError: false,
      summaryRequestId: 0,
      defaultProjectView: {
        name: '',
        daterange: [

        ],
        description: '',
        status: false,
        start: new Date(),
        end: new Date()
      },
      projectView: {
        name: '',
        daterange: '',
        description: '',
        status: false,
        start: new Date(),
        end: new Date(),
        tags: []
      },
      defaultCreateProjectView: {
        name: '',
        daterange: [],
        start: new Date(),
        end: new Date()
      },
      createProjectView: {
        name: '',
        daterange: '',
        status: false,
        start: new Date(),
        end: new Date()
      },
      pickerOptions: {
          shortcuts: [{
            text: 'Last week',
            onClick(picker) {
              const end = this.getEnd()//new Date();
              const start = this.getStart()//new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = this.getEnd()
              const start = this.getStart()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = this.getEnd()
              const start = this.getStart()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
    }
  },
  mounted: function () {
      var that = this;
      this.unsubscribeProjects = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'news/SET_ITEMS') {
          //stat loading starts right after fetch
        }

        if (mutation.type === 'news/PROJECT_UPDATED') {
          that.fetchData();//re-fetch to avoid custom property update
        }
    })
  },
  beforeDestroy () {
    if (this.unsubscribeProjects) this.unsubscribeProjects()
    this.summaryRequestId++
  },
  methods: {
    handleCloseIncludeTags(tag) {
        this.projectView.tags.splice(this.projectView.tags.indexOf(tag), 1);
    },
    addIncludeTag() {
        if (this.tagIncludeInput.length) {
            this.projectView.tags.push(this.tagIncludeInput);
            this.tagIncludeInput = '';
        }
    },
    handleStartStop(index, row) {
      switch (row.status) {
        case 'active' : {
          this.$store.dispatch('news/deactivateProjectAction', {
            params: {
              project_id: row.id,
              name: row.name
            }
          });
        } 
      case 'finished':
      case 'inactive':
        {
          this.$store.dispatch('news/activateProjectAction', {
            params: {
              project_id: row.id,
              name: row.name
            }
          });
        }
      }
    },
    getIcon(row) {
      switch (row.status) {
        case 'active' : {
          return 'el-icon-star-on';
        } 
        case 'finished' :
        case 'inactive' : {
          return 'el-icon-star-on';
        }
        default:
        {

        }
      }
    },
    fetchData() {
      this.$store.dispatch('news/getListPublic', { params: this.fetchParams })
      this.fetchSummary()
    },
    async fetchSummary () {
      const requestId = ++this.summaryRequestId
      this.summaryLoading = true
      this.summaryError = false
      this.summary = null
      try {
        const summary = await ProjectsService.fetchSummary()
        if (requestId === this.summaryRequestId) this.summary = summary
      } catch (error) {
        if (requestId === this.summaryRequestId) this.summaryError = true
      } finally {
        if (requestId === this.summaryRequestId) this.summaryLoading = false
      }
    },
    formatSummaryNumber (value) {
      return Number(value).toLocaleString('en-US')
    },
    tableRowClassName({row, rowIndex}) {
        if (row.status != 'active') {
          return 'warning-row';
        } else if (row.status == 'active') {
          return 'success-row';
        }
        return '';
    },
    handleEdit(index, row) {
      this.dialogVisible = true;
      this.projectView.id = row.id;
      this.projectView.name = row.name;
      this.projectView.description = row.description;
      this.projectView.status = (row.status == 'active') ? true : false;
      this.projectView.starting_at = new Date(row.starting_at);
      this.projectView.ending_at = new Date(row.ending_at);
      this.projectView.daterange = [
        new Date(row.starting_at),
        new Date(row.ending_at)
      ],
      this.projectView.tags = row.tags
    },
    handleСreate() {
      var dateFrom = new Date();
      var dateTo = new Date();
      dateTo.setMonth(dateFrom.getMonth()+6);
      this.createDialogVisible = true;
      this.createProjectView.name = '';
      this.createProjectView.starting_at = dateFrom;
      this.createProjectView.ending_at = dateTo;
      this.createProjectView.daterange = [
        dateFrom,
        dateTo
      ]
    },
    
    handleSaveNewProject() {
      var data = this.createProjectView;
      this.$store.dispatch('news/createProject', {
        data: data
      });
    },
    handleUpdateProject() {
      //update project via api
      this.dialogVisible = false;
      var data = this.projectView;
      this.$store.dispatch('news/updateProject', {
        data: data
      });
    },
    handleDelete(index, row) {
      var that = this;
      
      this.$confirm('Are you sure? You are about to delete ' + row.name + '?')
          .then(_ => {
            that.$store.dispatch('project/deleteProject', { 
              params: {
                project_id: row.id
              } 
            }).then(() => that.fetchData());
          })
          .catch(_ => {});
    },
    handleClose(done) {
        this.resetEditState();
        this.dialogVisible = false;
        this.createDialogVisible = false;
    },
    prepareEditDialog(row) {
      //return
      this.name = row.name;
    },
    filterHandler(value, row, column) {
        const property = column['property'];
        return row[property] === value;
    },
    resetEditState() {
      this.projectView = this.defaultProjectView;
      this.createProjectView = this.defaultCreateProjectView;
    },
    prepareNews() {
      var news = [];
      // filtering by status moved to server side
      news = this.news;

      if (this.nameFilter.length) { //filter by name
        news = this.news.filter(
          function(elem){
            if (elem.name.toLowerCase().indexOf(this.nameFilter.toLowerCase()) != -1) {
              return true;
            }
            
            if (elem.description && elem.description.toLowerCase().indexOf(this.nameFilter.toLowerCase()) != -1) {
              return true;
            }
          }, this
        );
      }
      return news;
      /* return news.sort(
        function (first, second) {
          if (first.updated_at < second.updated_at) {
            return 1;
          }

          if (first.updated_at > second.updated_at) {
            return -1;
          }

          return 0;
        }
      );*/
    },
    filterByName() {
      
    },
    getStart() {
      return this.projectView.starting_at;
    },
    getEnd() {
      return this.projectView.ending_at;
    },
    projectLink(row) {
      return {
        name: 'project',
        params: { id: row.id },
        query: this.useInUrlQueryPropList
      }
    },
    visibleProjectTags(tags) {
      return tags.filter(tag => tag.indexOf('BFP.') !== 0)
    },
    startDateFormatter(row, column) {
      return row.starting_at;
    },
    endDateFormatter(row, column) {
      return row.ending_at;
    },
    updatedDateFormatter(row, column) {
      return moment(row.updated_at).format('YYYY-MM-DD');
    },
    loadFailRate(row, column) {
      
    }
  },

  computed: {
    ...mapState('news', {
      news: 'items',
      pagination: 'pagination',
      error: 'error',
      loading: 'loading'
    }),
    ...mapGetters('news', [
      'isEmpty'
    ]),
    projectStateIcon(id) {
      
    },
    useInUrlQueryPropList () {
      return this.prepareQueryParamsMixin({
        limit: this.pagination.limit,
        page: this.pagination.page,
        show_all: this.showAll ? 1 : null
      })
    },
    fetchParams () {
      const fetchParameters = this.prepareFetchParamsMixin({
        sort: '-id',
        page: this.pagination.page,
        per_page: this.pagination.limit,
        status: (this.showAll ? null : 'active')
      })

      return { ...fetchParameters }
    },
  },

  created () {
    this.fetchData()
  }
}
</script>
